// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_ng-0";
export var buttonContainer = "_ng-3";
export var cancelButton = "_ng-4";
export var headerSection = "_ng-6";
export var headerTitle = "_ng-9";
export var messageSideLeft = "_ng-1";
export var messageSideRight = "_ng-2";
export var orderNumberContainer = "_ng-7";
export var orderNumberLabel = "_ng-8";
export var submitButton = "_ng-5";